import useGlobalLoading from "@/store/global-loading";
import { createPortal } from "react-dom";

const FullscreenLoading = () => {
    const { isLoading, loadingMessage } = useGlobalLoading();
    return isLoading
        ? createPortal(
              <div className="fixed left-0 top-0 z-50 flex h-screen w-screen flex-col items-center justify-center bg-white">
                  <img src={"/assets/images/others/loading.gif"} height={256} width={256} alt="loading" />
                  <h3 className=" animate-pulse text-lg font-semibold text-gray-700">{loadingMessage || "Please wait while we load the page."}</h3>
              </div>,
              document.body
          )
        : null;
};

export default FullscreenLoading;
